<script setup lang="ts">
import type { AuctionCar } from '@autobid/ui/types/Car'
import { useCarPower } from '@autobid/ui/composables/car/useCarPower'
import { getAmountOfOwners } from '@autobid/ui/utils/car/getAmountOfOwners'
import { getFirstRegistration } from '@autobid/ui/utils/car/getFirstRegistration'
import { computed } from 'vue'

interface Props {
  car: AuctionCar
  powerInTwoLines?: boolean
}

const props = defineProps<Props>()

const firstRegistration = computed(() =>
  getFirstRegistration(props.car.equipments),
)
const amountOfOwners = getAmountOfOwners(props.car.equipments)
const { powerTitle, getPower } = useCarPower()
const power = getPower(props.car.equipments)
</script>

<template>
  <div class="flex flex-wrap items-start text-sm md:text-base">
    <DynamicAuctionItemListCarParameter
      v-if="firstRegistration"
      class="lg:w-1/2"
      :title="firstRegistration.name"
      :value="firstRegistration.value"
    >
      <i class="ab-icon ab-icon-date h-6 md:h-8" />
    </DynamicAuctionItemListCarParameter>

    <ElementsCarMileageParameters class="lg:w-1/2" :car="car" />

    <DynamicAuctionItemListCarParameter
      v-if="power"
      :title="powerTitle"
      class="items-start lg:order-2 lg:w-1/2"
      :value="powerInTwoLines ? power.replace('/', '<br>') : power"
    >
      <div class="flex justify-center">
        <i class="ab-icon ab-icon-performance h-6 md:h-8" />
      </div>
    </DynamicAuctionItemListCarParameter>

    <DynamicAuctionItemListCarParameter
      v-if="amountOfOwners"
      class="lg:order-4 lg:w-1/2"
      :title="amountOfOwners.name"
      :value="amountOfOwners.value"
    >
      <i class="ab-icon ab-icon-owner h-6 md:h-8" />
    </DynamicAuctionItemListCarParameter>
  </div>
</template>
